<div class="main-container">

  <div class="well-info-item">
    <mat-label>VIDA ID's</mat-label>
    @if (wellRequest?.jobs?.length) {
      <span>
        @for (job of wellRequest?.jobs; track job; let last = $last) {
          {{ job.name }}@if (!last) {
          <span style="padding:0px; margin:0px">, </span>
        }
      }
      </span>
    }
  </div>

  <div class="well-info-item">
    <mat-label>Region</mat-label>
    <span>{{ wellRequest?.region }}</span>
  </div>

  <div class="well-info-item">
    <mat-label>Country</mat-label>
    <span>{{ wellRequest?.country }}</span>
  </div>

  <div class="well-info-item">
    <mat-label>Group Name</mat-label>
    @if (wellRequest?.groups?.length) {
      <span>
        @for (group of wellRequest?.groups; track group; let last = $last) {
          {{ group.name }}@if (!last) {
          <span style="padding:0px; margin:0px">, </span>
        }
      }
    </span>
  }
</div>

<div class="well-info-item">
  <mat-label>NWA</mat-label>
  @if (wellRequest?.groups?.length) {
    <span>
      @for (group of wellRequest?.groups; track group; let last = $last) {
        {{ group.nwa }}@if (!last) {
        <span style="padding:0px; margin:0px">, </span>
      }
    }
  </span>
}
</div>

<div class="well-info-item">
  <mat-label>State</mat-label>
  @if (wellRequest?.state) {
    <span>{{ wellRequest?.state }}</span>
  } @else {
    <span>N/A</span>
  }
</div>

<div class="well-info-item">
  <mat-label>District</mat-label>
  @if (wellRequest?.district) {
    <span>{{ wellRequest?.district }}</span>
  } @else {
    <span>N/A</span>
  }
</div>

<div class="well-info-item">
  <mat-label>Operator</mat-label>
  <span>{{ wellRequest?.operatorName }}</span>
</div>

<mat-grid-list class="coordinates-list" cols="2" rowHeight="60px" gutterSize="60px">
  <mat-grid-tile>
    <div class="well-info-item coordinates-item">
      <mat-label>Surface Latitude</mat-label>
      <span>{{ wellRequest?.latitude }}</span>
    </div>
  </mat-grid-tile>

  <mat-grid-tile>
    <div class="well-info-item coordinates-item">
      <mat-label>Surface Longitude</mat-label>
      <span>{{ wellRequest?.longitude }}</span>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<div class="well-info-item">
  <mat-label>Well API#</mat-label>
  <span>{{ wellRequest?.usCanadaWellId }}</span>
</div>

<div class="well-info-item">
  <mat-label>Well Type</mat-label>
  <span>{{ wellRequest?.wellType }}</span>
</div>

<div class="well-info-item">
  <mat-label>Depth</mat-label>
  <span>{{ wellRequest?.wellDepth }} ({{ wellRequest?.wellUOM }})</span>
</div>

<div class="well-info-item">
  <mat-label>Orientation</mat-label>
  <span>{{ wellRequest?.wellOrientation }}</span>
</div>

<div class="well-info-item">
  <mat-label>Rig</mat-label>
  <span>{{ wellRequest?.rigName }}</span>
</div>

<div class="well-info-item">
  <mat-label>Rig Owner Company</mat-label>
  <span>{{ getRigOwner(wellRequest) }}</span>
</div>

<div class="well-info-item">
  <mat-label>Rig Drilling Type</mat-label>
  <span>{{ getDrillingType(wellRequest) }}</span>
</div>

<div class="well-info-item">
  <mat-label>Rig Source</mat-label>
  <span>{{ getRigSource(wellRequest) }}</span>
</div>

<div class="well-info-item">
  <mat-label>Well Source</mat-label>
  <span>{{ wellRequest?.wellSource }}</span>
</div>

</div>
